import { render, staticRenderFns } from "./index.vue?vue&type=template&id=83073e52&"
import script from "./navbar.js?vue&type=script&lang=js&"
export * from "./navbar.js?vue&type=script&lang=js&"
import style0 from "./navbar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports